/* Cart-drawer Cart | Wishlist hub.
   Adds the tab toggle + wishlist panel behaviour to the cart drawer. Reads BokjaWishlist (the
   adapter in bokja-wishlist.js) for the saved set, fetches the bokja-wishlist section via the search
   section-rendering endpoint (the same id:-query pattern recently-viewed uses), and manages the tab
   state, the wishlist count and per-item remove. Loaded as a real asset from bokja-cart-drawer.liquid
   (a header-rendered snippet's inline script is not executed by Horizon's per-page bundle).

   Add-to-cart from the panel is wired in a later phase. Fail-safe: any error just leaves the cart
   untouched. */
(function () {
  if (window.__bokjaCartWishlistBound) return;
  window.__bokjaCartWishlistBound = true;

  function W() { return window.BokjaWishlist; }

  function updateCounts() {
    var n = W() ? W().count() : 0;
    document.querySelectorAll('[data-bokja-tabcount-wishlist]').forEach(function (el) { el.textContent = '(' + n + ')'; });
    // header heart badge: plain count, hidden at zero
    document.querySelectorAll('[data-bokja-wishlist-badge]').forEach(function (el) {
      el.textContent = n > 0 ? String(n) : '';
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  var lastKey = null;
  async function populate(force) {
    var mount = document.querySelector('[data-bokja-wishlist-mount]');
    var empty = document.querySelector('[data-bokja-wishlist-empty]');
    if (!mount) return;
    var ids = W() ? W().getIds() : [];
    if (!ids.length) {
      mount.innerHTML = '';
      if (empty) empty.hidden = false;
      lastKey = '';
      return;
    }
    if (empty) empty.hidden = true;
    var key = ids.join(',');
    if (!force && key === lastKey && mount.children.length) return;
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    try {
      var res = await fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=bokja-wishlist', { headers: { Accept: 'text/html' } });
      if (!res.ok) return;
      var html = (await res.text()).trim();
      mount.innerHTML = html;
      // present most-recently-saved first
      var list = mount.querySelector('.bokja-wishlist-items');
      if (list) {
        ids.slice().reverse().forEach(function (id) {
          var el = list.querySelector('[data-bokja-wishlist-id="' + id + '"]');
          if (el) list.appendChild(el);
        });
      }
      lastKey = key;
    } catch (e) {}
  }

  function isWishlistTab() {
    var c = document.querySelector('.cart-drawer__content');
    return !!(c && c.classList.contains('is-wishlist'));
  }

  function setTab(name) {
    var content = document.querySelector('.cart-drawer__content');
    if (!content) return;
    content.classList.toggle('is-wishlist', name === 'wishlist');
    document.querySelectorAll('[data-bokja-tab]').forEach(function (t) {
      var on = t.getAttribute('data-bokja-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (name === 'wishlist') populate(true);
  }

  document.addEventListener('click', function (e) {
    // Header wishlist heart: open the cart drawer (native trigger, keeps the user gesture), then
    // show the Wishlist tab. Works whether the cart is empty or not (the empty drawer has tabs too).
    var openW = e.target.closest && e.target.closest('[data-bokja-open-wishlist]');
    if (openW) {
      var trigger = document.querySelector('.bokja-nav__cart--trigger, [data-testid="cart-drawer-trigger"]');
      if (trigger) trigger.click();
      setTimeout(function () { setTab('wishlist'); }, 0);
      return;
    }

    var tab = e.target.closest && e.target.closest('[data-bokja-tab]');
    if (tab) { e.preventDefault(); setTab(tab.getAttribute('data-bokja-tab')); return; }

    var add = e.target.closest && e.target.closest('[data-bokja-wishlist-add]');
    if (add) {
      e.preventDefault();
      if (typeof window.BokjaCartAdd !== 'function') return;
      var li = add.closest('.bokja-wishlist-item');
      var pid = li && li.getAttribute('data-bokja-wishlist-id');
      var variant = add.getAttribute('data-variant-id');
      // prefer the variant the shopper saved on the PDP (respects the chosen size)
      if (W() && pid) {
        var saved = W().getAll().filter(function (i) { return String(i.id) === String(pid); })[0];
        if (saved && saved.variant) variant = saved.variant;
      }
      if (!variant) return;
      add.classList.add('is-adding');
      window.BokjaCartAdd(variant, add).then(function () { add.classList.remove('is-adding'); });
      // the cart morph that follows re-renders the drawer to the Cart tab with the new item
      return;
    }

    var rm = e.target.closest && e.target.closest('[data-bokja-wishlist-remove]');
    if (rm) {
      e.preventDefault();
      if (W()) W().remove(rm.getAttribute('data-bokja-wishlist-remove'));
      populate(true);
      updateCounts();
    }
  });

  document.addEventListener('bokja:wishlist:change', function () {
    updateCounts();
    if (isWishlistTab()) populate(true);
  });

  // Drawer open + cart morph: keep the count fresh, and refresh the panel if it is showing. Mirror
  // the recents watcher (MutationObserver on the dialog [open] + delegated trigger click).
  function onOpen() { updateCounts(); if (isWishlistTab()) populate(true); }
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var d = muts[i].target;
        if (d.nodeType === 1 && d.classList && d.classList.contains('cart-drawer__dialog') && d.hasAttribute('open')) onOpen();
      }
    });
    var raf = null;
    var watch = function () {
      var dlg = document.querySelector('.cart-drawer__dialog');
      if (dlg && !dlg.__bokjaWishWatched) {
        dlg.__bokjaWishWatched = true;
        obs.observe(dlg, { attributes: true, attributeFilter: ['open'] });
        if (dlg.hasAttribute('open')) onOpen();
      }
      // After a cart morph re-renders the drawer children, restore the wishlist count.
      var inner = document.querySelector('.cart-drawer__inner');
      if (inner && !inner.__bokjaWishMorph) {
        inner.__bokjaWishMorph = true;
        new MutationObserver(function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = null; updateCounts(); });
        }).observe(inner, { childList: true, subtree: true });
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.bokja-nav__cart--trigger, [data-testid="cart-drawer-trigger"]');
    if (t) setTimeout(onOpen, 60);
  }, true);

  updateCounts();
})();
